import React from 'react';
import { useSelector } from 'react-redux';

import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';
import DateFilter from 'components/ReactTable/Filters/DateFilter';
import SelectFilter from 'components/ReactTable/Filters/SelectFilter';
import GetOptions from 'components/HomePage/GridColumnDefinitions/GetOptions';

const whsManagementColumnDefs = () => [
  {
    Header: 'Account',
    accessor: 'account',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<AccountLinkCell dataKey="accountId" data={ original } permissions={ useSelector(state => state.auth.permissions) } />);
    },
    className: 'col-15p',
    sortIconId: 'sort-account',
    filterIconId: 'filter-icon-account',
    filterTextFieldId: 'filter-text-field-account'
  },
  {
    Header: 'Customer',
    accessor: 'customer',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<CustomerLinkCell dataKey="customerDbId" data={ original } permissions={ useSelector(state => state.auth.permissions) } />);
    },
    className: 'col-15p',
    sortIconId: 'sort-customer',
    filterIconId: 'filter-icon-customer',
    filterTextFieldId: 'filter-text-field-customer'
  },
  {
    Header: 'WHS Name',
    accessor: 'whsName',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-12p5'
  },
  {
    Header: 'WHS Type',
    accessor: 'statementType',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-7p'
  },
  {
    Header: 'WHS Valid',
    accessor: 'isValid',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isValid'),
    className: 'col-7p',
    sortIconId: 'sort-is-valid',
    filterIconId: 'filter-icon-is-valid',
  },
  {
    Header: 'Allocation',
    accessor: 'allocation',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-7p'
  },
  {
    Header: 'Forms Valid',
    accessor: 'formsValid',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-5p'
  },
  {
    Header: 'Forms Invalid',
    accessor: 'formsInvalid',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-5p'
  },
  {
    Header: 'Undocumented',
    accessor: 'formsUndocumented',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-6p5'
  },
  {
    Header: 'Date From',
    accessor: 'dateFrom',
    className: 'col-7p5',
    Filter: DateFilter,
    sortIconId: 'sort-date-from',
    filterIconId: 'filter-icon-date-from',
    filterTextFieldId: 'filter-text-field-date-from'
  },
  {
    Header: 'Date To',
    accessor: 'dateTo',
    className: 'col-7p5',
    Filter: DateFilter,
    sortIconId: 'sort-date-to',
    filterIconId: 'filter-icon-date-to',
    filterTextFieldId: 'filter-text-field-date-to'
  },
];

export default whsManagementColumnDefs;
